import type {
  AccountBranding,
  NormalisedAccountBranding,
} from "models/types/agency-settings";

const removeFileExtension = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex === -1) {
    return fileName;
  }
  return fileName.slice(0, lastDotIndex);
};

export const normaliseAccountBranding = (
  branding: AccountBranding,
): NormalisedAccountBranding => {
  if (branding.heading_font) {
    branding.heading_font.name = removeFileExtension(
      branding.heading_font.name,
    );
  }

  if (branding.body_font) {
    branding.body_font.name = removeFileExtension(branding.body_font.name);
  }

  const normalisedBranding = {
    ...branding,
    heading_font_family: branding.heading_font_family ?? branding.heading_font,
    body_font_family: branding.body_font_family ?? branding.body_font,
  };

  return normalisedBranding;
};
